import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const CheckIcon = _ref => {
  let {
      size = "16",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M19.1047 6.09513C19.5383 5.65579 20.2413 5.65579 20.6748 6.09513C21.1031 6.52908 21.1083 7.22935 20.6906 7.66983L11.8204 18.1552C11.8118 18.166 11.8027 18.1763 11.7931 18.1861C11.3595 18.6255 10.6566 18.6255 10.223 18.1861L4.82518 12.7165C4.39161 12.2771 4.39161 11.5648 4.82518 11.1255C5.25874 10.6861 5.9617 10.6861 6.39526 11.1255L10.9746 15.7657L19.0753 6.12878C19.0844 6.11698 19.0943 6.10574 19.1047 6.09513Z",
    fill: color
  }));
};
export default CheckIcon;